import { useTranslation } from "react-i18next";
const HeroPage = () => {
  const { t } = useTranslation("translations");
  return (
    <div className="container text-center mx-auto mt-[100px] md:mt-[70px] mb-4 flex flex-col justify-center align-center bg-white">
      <h1 className="font-bold  text-3xl md:text-5xl">{t('package_title')}</h1>
      <p className="text-base pt-1.5 max-w-[480px] mx-auto">
        {t('package_capt')}
      </p>
    </div>
  );
};

export default HeroPage;
